export default ngModule => {

  ngModule.controller('WelcomeCtrl', function ($state, AonConfig, Auth, $location) {

    // Check for a querystring containing the auth code, and suppress the login box if
    // present and correct
    this.suppress_login = false;
    if ($location.search().hasOwnProperty('net')) {
      this.password = $location.search().net;
      const success = () => { this.suppress_login = true; }
      const error = () => { }
      Auth.login(this.password).then(success, error);
    }

    this.corporate = AonConfig.corporate;
    this.deployment = AonConfig.deployment;
    this.submit = (code) => {
      this.loginFailed = false;
      const success = () => {
        if (AonConfig.corporate.redirect_url) {
          window.location = AonConfig.corporate.redirect_url;
          return;
        }
        if (AonConfig.corporate.is_operator) {
          $state.transitionTo('operator.step1');
        } else {
          $state.transitionTo('comparator.step1');
        }
      },
        error = () => { this.loginFailed = true; };
      Auth.login(code).then(success, error);
    };
  });

};


// WEBPACK FOOTER //
// ./src/controllers/comparator/welcome-ctrl.js